import React, { useEffect } from "react";
import PageTitle from "../../layout/PageTitle";

function PrivacyPolicy({ setTab }) {
  useEffect(() => {
    setTab("home");
  }, [setTab]);
  return (
    <>
      <PageTitle page="Privacy Policy" setTab={setTab} />
      <section
        className="ttm-row zero_padding-section ttm-bgcolor-grey clearfix"
        style={{ padding: "40px 0" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>
                Privacy Policy for Prasad{" "}
                <span style={{ color: "#12b48b" }}>Eye </span>
                Hospital
              </h2>
              <p>
                <span>
                  At Prasad Eye Hospital, accessible from
                  https://prasadeyehospital.co.in/, one of our main priorities
                  is the privacy of our visitors. This Privacy Policy document
                  contains types of information that is collected and recorded
                  by Prasad Eye Hospital and how we use it.
                </span>
              </p>
              <p>
                <span>
                  If you have additional questions or require more information
                  about our Privacy Policy, do not hesitate to contact us.
                </span>
              </p>
              <p>
                <span>
                  This Privacy Policy applies only to our online activities and
                  is valid for visitors to our website with regards to the
                  information that they shared and/or collect in Prasad Eye
                  Hospital. This policy is not applicable to any information
                  collected offline or via channels other than this website.
                </span>
              </p>
              <h4>
                <span>Consent</span>
              </h4>
              <p>
                <span>
                  By using our website, you hereby consent to our Privacy Policy
                  and agree to its terms.
                </span>
              </p>
              <h4>
                <span>Information we collect</span>
              </h4>
              <p>
                <span>
                  The personal information that you are asked to provide, and
                  the reasons why you are asked to provide it, will be made
                  clear to you at the point we ask you to provide your personal
                  information.
                </span>
              </p>
              <p>
                <span>
                  If you contact us directly, we may receive additional
                  information about you such as your name, email address, phone
                  number, the contents of the message and/or attachments you may
                  send us, and any other information you may choose to provide.
                </span>
              </p>
              <p>
                <span>
                  When you register for an Account, we may ask for your contact
                  information, including items such as name, company name,
                  address, email address, and telephone number.
                </span>
              </p>
              <h4>
                <span>How we use your information</span>
              </h4>
              <p>
                <span>
                  We use the information we collect in various ways, including
                  to:
                </span>
              </p>
              <ul>
                <li>
                  <span>Provide, operate, and maintain our website</span>
                </li>
                <li>
                  <span>Improve, personalize, and expand our website</span>
                </li>
                <li>
                  <span>Understand and analyze how you use our website</span>
                </li>
                <li>
                  <span>
                    Develop new products, services, features, and functionality
                  </span>
                </li>
                <li>
                  <span>
                    Communicate with you, either directly or through one of our
                    partners, including for customer service, to provide you
                    with updates and other information relating to the website,
                    and for marketing and promotional purposes
                  </span>
                </li>
                <li>
                  <span>Send you emails</span>
                </li>
                <li>
                  <span>Find and prevent fraud</span>
                </li>
              </ul>
              <h4>
                <span>Log Files</span>
              </h4>
              <p>
                <span>
                  Prasad Eye Hospital follows a standard procedure of using log
                  files. These files log visitors when they visit websites. All
                  hosting companies do this and a part of hosting services'
                  analytics. The information collected by log files include
                  internet protocol (IP) addresses, browser type, Internet
                  Service Provider (ISP), date and time stamp, referring/exit
                  pages, and possibly the number of clicks. These are not linked
                  to any information that is personally identifiable. The
                  purpose of the information is for analyzing trends,
                  administering the site, tracking users' movement on the
                  website, and gathering demographic information.
                </span>
              </p>
              <h4>
                <span>Advertising Partners Privacy Policies</span>
              </h4>
              <p>
                <span>
                  You may consult this list to find the Privacy Policy for each
                  of the advertising partners of Prasad Eye Hospital.
                </span>
              </p>
              <p>
                <span>
                  Third-party ad servers or ad networks uses technologies like
                  cookies, JavaScript, or Web Beacons that are used in their
                  respective advertisements and links that appear on Prasad Eye
                  Hospital, which are sent directly to users' browser. They
                  automatically receive your IP address when this occurs. These
                  technologies are used to measure the effectiveness of their
                  advertising campaigns and/or to personalize the advertising
                  content that you see on websites that you visit.
                </span>
              </p>
              <p>
                <span>
                  Note that Prasad Eye Hospital has no access to or control over
                  these cookies that are used by third-party advertisers.
                </span>
              </p>
              <h4>
                <span>Third Party Privacy Policies</span>
              </h4>
              <p>
                <span>
                  Prasad Eye Hospital's Privacy Policy does not apply to other
                  advertisers or websites. Thus, we are advising you to consult
                  the respective Privacy Policies of these third-party ad
                  servers for more detailed information. It may include their
                  practices and instructions about how to opt-out of certain
                  options.
                </span>
              </p>
              <p>
                <span>
                  You can choose to disable cookies through your individual
                  browser options. To know more detailed information about
                  cookie management with specific web browsers, it can be found
                  at the browsers' respective websites.
                </span>
              </p>
              <h4>
                <span>
                  CCPA Privacy Rights (Do Not Sell My Personal Information)
                </span>
              </h4>
              <p>
                <span>
                  Under the CCPA, among other rights, California consumers have
                  the right to:
                </span>
              </p>
              <p>
                <span>
                  Request that a business that collects a consumer's personal
                  data disclose the categories and specific pieces of personal
                  data that a business has collected about consumers.
                </span>
              </p>
              <p>
                <span>
                  Request that a business delete any personal data about the
                  consumer that a business has collected.
                </span>
              </p>
              <p>
                <span>
                  Request that a business that sells a consumer's personal data,
                  not sell the consumer's personal data.
                </span>
              </p>
              <p>
                <span>
                  If you make a request, we have one month to respond to you. If
                  you would like to exercise any of these rights, please contact
                  us.
                </span>
              </p>
              <h4>
                <span>GDPR Data Protection Rights</span>
              </h4>
              <p>
                <span>
                  We would like to make sure you are fully aware of all of your
                  data protection rights. Every user is entitled to the
                  following:
                </span>
              </p>
              <p>
                <span>
                  The right to access &ndash; You have the right to request
                  copies of your personal data. We may charge you a small fee
                  for this service.
                </span>
              </p>
              <p>
                <span>
                  The right to rectification &ndash; You have the right to
                  request that we correct any information you believe is
                  inaccurate. You also have the right to request that we
                  complete the information you believe is incomplete.
                </span>
              </p>
              <p>
                <span>
                  The right to erasure &ndash; You have the right to request
                  that we erase your personal data, under certain conditions.
                </span>
              </p>
              <p>
                <span>
                  The right to restrict processing &ndash; You have the right to
                  request that we restrict the processing of your personal data,
                  under certain conditions.
                </span>
              </p>
              <p>
                <span>
                  The right to object to processing &ndash; You have the right
                  to object to our processing of your personal data, under
                  certain conditions.
                </span>
              </p>
              <p>
                <span>
                  The right to data portability &ndash; You have the right to
                  request that we transfer the data that we have collected to
                  another organization, or directly to you, under certain
                  conditions.
                </span>
              </p>
              <p>
                <span>
                  If you make a request, we have one month to respond to you. If
                  you would like to exercise any of these rights, please contact
                  us.
                </span>
              </p>
              <h4>
                <span>Children's Information</span>
              </h4>
              <p>
                <span>
                  Another part of our priority is adding protection for children
                  while using the internet. We encourage parents and guardians
                  to observe, participate in, and/or monitor and guide their
                  online activity.
                </span>
              </p>
              <p>
                <span>
                  Prasad Eye Hospital does not knowingly collect any Personal
                  Identifiable Information from children under the age of 13. If
                  you think that your child provided this kind of information on
                  our website, we strongly encourage you to contact us
                  immediately and we will do our best efforts to promptly remove
                  such information from our records.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
